<template>
  <v-dialog
    v-model="display"
    max-width="500"
    content-class="rounded-lg elevation-0"
    @keydown.enter="display = false"
    :persistent="persistent"
    :fullscreen="fullscreen"
    :transition="fullscreen ? 'scroll-y-reverse-transition' : 'scale-transition'"
  >
    <v-card elevation="0" rounded="lg" class="nauta-migration-help-modal-card">
      <div class="nauta-migration-help-modal-content">
        <div class="nauta-migration-help-modal-text-container">
          <h3 class="nauta-migration-help-modal-title">
            {{ $t("nautaMigration.helpModal.title") }}
          </h3>
          <div class="nauta-migration-help-modal-text">
            {{ $t("nautaMigration.helpModal.text") }}
          </div>
        </div>
        <div class="nauta-migration-help-modal-button-row">
          <div class="nauta-migration-help-modal-help-center-button">
            <NewButton
              :text="$t('nautaMigration.helpModal.helpCenter')"
              icon="mdi-face-agent"
              link="https://ayuda.dvacapital.com/es/"
            />
          </div>
          <div class="nauta-migration-help-modal-chat-with-us-button">
            <NewButton
              :text="$t('nautaMigration.helpModal.chatWithUs')"
              link="https://wa.me/+56982128541"
              icon="mdi-whatsapp"
            />
          </div>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import NewButton from "@/components/shared/NewButton.vue";

export default {
  name: "HelpModal",

  components: { NewButton },

  props: {
    value: Boolean,
    title: String,
    fullscreen: Boolean,
    persistent: Boolean,
  },

  computed: {
    display: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("display", value);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.nauta-migration-help-modal-content {
  height: 100%;
  padding: 40px;
  @media (max-width: 600px) {
    padding: 20px;
  }
}

.nauta-migration-help-modal-title {
font-size: 36px;
  font-weight: 600;
  line-height: 110%;
  letter-spacing: -0.72px;
  text-align: center;
  color: #333333;
}
.nauta-migration-help-modal-text-container {
  @media (max-width: 600px) {
    margin: 20px;
  }
}

.nauta-migration-help-modal-text {
  color: #646363;
  text-align: center;
  font-family: "Work Sans";
  font-size: 14px;
  font-weight: 500;
  line-height: 160%;
  margin-top: 16px;
}

.nauta-migration-help-modal-button-row {
  margin-top: 40px;
  display: flex;
  flex-direction: column;

  gap: 12px 0;
}

.nauta-migration-help-modal-chat-with-us-button ::v-deep .new-btn {
  background-color: #0B5934 !important;
}

</style>
